<p-toast></p-toast>
<div>
    <div class="card mt-2">
        <h5>{{'BASIC_DETAILS_OF_REQUEST'| translate}}</h5>
        <form [formGroup]="basicDetailsForm">


            <div class="p-fluid p-formgrid grid mt-5">
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'FARMER_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.FarmerName}}" pInputText
                        id="farmerName" type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="VendorName">{{'VENDOR_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.VendorName}}" pInputText
                        id="VendorName" type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="JEName">{{'JE_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.JEName}}" pInputText id="JEName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6" *ngIf="!jeLogin">
                    <label htmlFor="XENName">{{'XEN_NAME'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.XENName}}" pInputText id="XENName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="JERemarks">{{'JE_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.JERemarks}}" pInputText id="JERemarks"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6" *ngIf="!jeLogin">
                    <label htmlFor="XENRemarks">{{'XEN_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.XENRemarks}}" pInputText
                    id="XENRemarks" type="text" />
                </div>
                <div class="field col-12 md:col-6" *ngIf="!(jeLogin || xenLogin)">
                    <label htmlFor="DARemarks">{{'DA_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.DARemarks}}" pInputText id="DARemarks"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6" *ngIf="!(jeLogin || xenLogin || ddAssociateLogin)">
                    <label htmlFor="DARemarks">{{'DMICADA_REMARKS'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.DMICADARemarks}}" pInputText id="DARemarks"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'FINANCIAL_YEAR'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.FinancialYear}}" pInputText
                        id="farmerName" type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'APPLICATION_NO'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.AppID}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'DISTRICT'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.District}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'BLOCK'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.Block}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'VILLAGE'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.Village}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'CROP'| translate}}</label>
                    <input readonly value="{{physicalVerficationApplicationData?.CropName}}" pInputText id="farmerName"
                        type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'SPACING'| translate}}</label>
                    <input readonly
                        value="{{physicalVerficationApplicationData?.PlantSpacing}} X {{physicalVerficationApplicationData?.RowSpacing}}"
                        pInputText id="farmerName" type="text" />
                </div>
                <div class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'AREA'| translate}}</label>
                    <input *ngIf="(ddAssociateLogin || dimicadaLogin)" formControlName="MIArea" pInputText type="text" id="MIArea"/>
                    <input *ngIf="!(ddAssociateLogin || dimicadaLogin)" readonly value="{{physicalVerficationApplicationData?.MIArea}}" pInputText id="farmerName"
                        type="text"/>
                        <div *ngIf="basicDetailsFormControls.MIArea.touched && basicDetailsFormControls.MIArea.errors" class="invalid-feedback">
                            <div *ngIf="basicDetailsFormControls.MIArea.errors.required">{{'AREA_IS_REQUIRED'| translate}}
                            </div>
                            <div *ngIf="basicDetailsFormControls.MIArea.errors.min">{{'AREA_MUST_GREATER_OR_EQUAL_TO_1'| translate}}
                            </div>
                        </div>
                    <!-- "{{physicalVerficationApplicationData?.MIArea}}" -->
                    <!-- [(ngModel)]="landArea" -->
                </div>
                <!-- <div class="field col-12 md:col-6">
          <label htmlFor="farmerName">{{'GPS_COORDINATE'| translate}}</label> -->
                <!-- <button pButton pRipple type="button" pTooltip="Edit-Estimation"
            icon="pi pi-replay" class="p-button-rounded p-button-text"></button> -->
                <!-- <input readonly
            value="Lat : {{physicalVerficationApplicationData?.Lat ? physicalVerficationApplicationData?.Lat : latPosition}} , Long : {{physicalVerficationApplicationData?.Long ? physicalVerficationApplicationData?.Long : longPosition}}"
            pInputText id="farmerName" type="text" />
        </div> -->
                <div class="field col-12 md:col-12">
                    <label htmlFor="farmerName">{{'KILLA_NUMBER_OF_MI_SYSTEMS_INSTALLED'| translate}}</label>
                    <!-- <textarea readonly value="{{physicalVerficationApplicationData?.LandDetail}}" id="killaNoTA" type="text" onkeyup="autoheight('killaNoTA')"></textarea> -->
                    <!-- <textarea rows="5" cols="30" readonly value="{{physicalVerficationApplicationData?.LandDetail}}" pInputTextarea></textarea> -->
                    <textarea rows="5" cols="30" readonly value="{{physicalVerficationApplicationData?.LandDetail}}"
                        pInputTextarea></textarea>
                </div>
                <div *ngIf="xenLogin" class="field col-12 md:col-6">
                    <label htmlFor="farmerName">{{'SURVEY_TYPE'| translate}}</label>
                    <div class="field-radiobutton">
                        <p-radioButton name="OfficeSurvey" [ngModelOptions]="{standalone: true}" value="0"
                            (click)="getSurveyType(0)" [(ngModel)]="selectedSurveyType" inputId="0"></p-radioButton>
                        <label for="0">From Office</label>
                    </div>
                    <div class="field-radiobutton">
                        <p-radioButton name="FieldSurvey" [ngModelOptions]="{standalone: true}" value="1"
                            (click)="getSurveyType(1)" [(ngModel)]="selectedSurveyType" inputId="1"></p-radioButton>
                        <label for="1">From Field</label>
                    </div>
                </div>
            </div>
            <div class="bank-details-container">
                
                <!-- Pre estimation coordinates mobile view -->
                <!-- <div > -->
                <div class="card block md:hidden" style="padding:0.5rem">
                    <h5>{{'PRE_ESTIMATION_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                        translate}})</h5>
                        <div *ngIf="preEstimationGeolocationsArray && preEstimationGeolocationsArray.length == 0"><p> Data Not Found </p></div>
                    <div style="padding: 0 1em;">
                        <p-card styleClass="p-card-shadow my-2 widthFull"
                            *ngFor="let item of preEstimationGeolocationsArray; let i=index">
                            <!-- <table cellspacing="1"> -->
                            <table cellspacing="10" style="margin-left: -12px;">
                                <tr>
                                    <td><b>{{'CORNER_ID'| translate}}</b></td>
                                    <td class="surveyEstimateTable"><b>{{item.CornerID}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>{{'LATITUDE'| translate}}</b></td>
                                    <td class="surveyEstimateTable">{{item.lat}}</td>
                                </tr>
                                <tr>
                                    <td><b>{{'LONGITUDE'| translate}}</b></td>
                                    <td class="surveyEstimateTable">{{item.lng}}</td>
                                </tr>
                                <tr *ngIf="jeLogin">
                                    <td><b>{{'ACTIONS'| translate}}</b></td>
                                    <td>
                                        <button (click)="onDelect(i, false)" pButton pRipple type="button"
                                            icon="pi pi-times" class="p-button-success mr-2 mb-2 size-btn"></button>
                                    </td>
                                </tr>
                            </table>
                        </p-card>
                        <p-gmap *ngIf="preEstimationGeolocationsArray && preEstimationGeolocationsArray.length>0" #gmap
                            [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="preEstimateMapoptions"
                            [overlays]="preEstimationMapoverlays"></p-gmap>
                    </div>
                </div>
                <!-- Pre estimation coordinates mobile view end -->

                <!-- Pre estimation coordinates desktop view -->
                <div class="card hidden md:block">
                    <h5>{{'PRE_ESTIMATION_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                    <div *ngIf="preEstimationGeolocationsArray && preEstimationGeolocationsArray.length == 0"><p> Data Not Found </p></div>
                    <div *ngIf="preEstimationGeolocationsArray && preEstimationGeolocationsArray.length>0" class="dashboardTable">
                        <p-table [value]="preEstimationGeolocationsArray" #preEstimationGeolocationsArrayTable dataKey="AppID" [rows]="10"
                            responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{'CORNER_ID' | translate}}
                                        <!-- <p-columnFilter type="text" field="CornerID" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="CornerID"></p-sortIcon> -->
                                    </th>
                                    <th>{{'LATITUDE'| translate}}
                                        <!-- <p-columnFilter type="text" field="lat" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="lat"></p-sortIcon> -->
                                    </th>
                                    <th>{{'LONGITUDE'| translate}}
                                        <!-- <p-columnFilter type="text" field="lng" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="lng"></p-sortIcon> -->
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                <tr>
                                    <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                    <td class="surveyEstimateTable">{{product.lat}}</td>
                                    <td class="surveyEstimateTable">{{product.lng}}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="flex align-items-center justify-content-between">
                                    {{'IN_TOTAL_THERE_ARE'| translate}} {{preEstimationGeolocationsArray ?
                                        preEstimationGeolocationsArray.length : 0 }} {{'CAPTURE_GPS_COORDINATES_ADDED' | translate}}.
                                </div>
                            </ng-template>
                        </p-table>
                        <p-gmap *ngIf="preEstimationGeolocationsArray && preEstimationGeolocationsArray.length>0" #gmap
                            [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="preEstimateMapoptions"
                            [overlays]="preEstimationMapoverlays"></p-gmap>
                    </div>
                </div>
                <!-- Pre estimation coordinates desktop view end -->

                <div class="card block md:hidden" style="padding:0.5rem">
                    <h5 *ngIf="!jeorxenLogin || xenLogin">{{'JE_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                        translate}})</h5>
                    <h5 *ngIf="jeLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                    <div style="padding: 0 1em;">
                        <p-card styleClass="p-card-shadow my-2 widthFull"
                            *ngFor="let item of jegeolocationsarray; let i=index">
                            <!-- <table cellspacing="1"> -->
                            <table cellspacing="10" style="margin-left: -12px;">
                                <tr>
                                    <td><b>{{'CORNER_ID'| translate}}</b></td>
                                    <td class="surveyEstimateTable"><b>{{item.CornerID}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>{{'LATITUDE'| translate}}</b></td>
                                    <td class="surveyEstimateTable">{{item.lat}}</td>
                                </tr>
                                <tr>
                                    <td><b>{{'LONGITUDE'| translate}}</b></td>
                                    <td class="surveyEstimateTable">{{item.lng}}</td>
                                </tr>
                                <tr *ngIf="jeLogin">
                                    <td><b>{{'ACTIONS'| translate}}</b></td>
                                    <td>
                                        <button (click)="onDelect(i, false)" pButton pRipple type="button"
                                            icon="pi pi-times" class="p-button-success mr-2 mb-2 size-btn"></button>
                                    </td>
                                </tr>
                            </table>

                        </p-card>
                        <p-gmap *ngIf="jegeolocationsarray && jegeolocationsarray.length>0" #gmap
                            [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="jeMapoptions"
                            [overlays]="jeMapoverlays"></p-gmap>

                        <!-- </div> -->
                        <div *ngIf="jeLogin" class="my-2 proDataButton">
                            <p class="invalid-feedback"
                                *ngIf="jegeolocationsarray && jegeolocationsarray.length<4 && coordinateError">
                                {{coordinateError}}</p>
                            <button pButton pRipple type="submit" (click)="onCapture(false)"
                                label="{{'CAPTURE_GPS_COORDINATES'| translate}}"
                                class="p-button-info mr-2 mb-2"></button>
                        </div>
                    </div>
                </div>
                <div class="card hidden md:block">
                    <h5 *ngIf="!jeorxenLogin || xenLogin">{{'JE_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                        translate}})</h5>
                    <h5 *ngIf="jeLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                    <div *ngIf="jegeolocationsarray && jegeolocationsarray.length>0" class="dashboardTable">
                        <p-table [value]="jegeolocationsarray" #geolocationsarrayTable dataKey="AppID" [rows]="10"
                            responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{'CORNER_ID' | translate}}
                                        <!-- <p-columnFilter type="text" field="CornerID" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="CornerID"></p-sortIcon> -->
                                    </th>
                                    <th>{{'LATITUDE'| translate}}
                                        <!-- <p-columnFilter type="text" field="lat" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="lat"></p-sortIcon> -->
                                    </th>
                                    <th>{{'LONGITUDE'| translate}}
                                        <!-- <p-columnFilter type="text" field="lng" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="lng"></p-sortIcon> -->
                                    </th>
                                    <th *ngIf="jeLogin">{{'ACTIONS'| translate}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                <tr>
                                    <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                    <td class="surveyEstimateTable">{{product.lat}}</td>
                                    <td class="surveyEstimateTable">{{product.lng}}</td>
                                    <td *ngIf="jeLogin" class="surveyEstimateTable">
                                        <button (click)="onDelect(rowIndex, false)" pButton pRipple type="button"
                                            icon="pi pi-times" class="p-button-success mr-2 mb-2 size-btn"></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="flex align-items-center justify-content-between">
                                    {{'IN_TOTAL_THERE_ARE'| translate}} {{jegeolocationsarray ?
                                    jegeolocationsarray.length : 0 }} {{'CAPTURE_GPS_COORDINATES_ADDED' | translate}}.
                                </div>
                            </ng-template>
                        </p-table>
                        <p-gmap *ngIf="jegeolocationsarray && jegeolocationsarray.length>0" #gmap
                            [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="jeMapoptions"
                            [overlays]="jeMapoverlays"></p-gmap>

                    </div>
                    <div *ngIf="jeLogin" class="my-2 proDataButton">
                        <p class="invalid-feedback"
                            *ngIf="jegeolocationsarray && jegeolocationsarray.length<4 && coordinateError">
                            {{coordinateError | translate}}</p>
                        <button pButton pRipple type="submit" (click)="onCapture(false)"
                            label="{{'CAPTURE_GPS_COORDINATES' | translate}}" class="p-button-info mr-2 mb-2"></button>
                    </div>

                </div>
                <!-- Hidden on small screens -->
            </div>
            <div *ngIf="xenLogin || !jeorxenLogin" class="bank-details-container">
                <div class="card block md:hidden" style="padding:0.5rem">
                    <h5 *ngIf="!jeorxenLogin">{{'XEN_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})
                    </h5>
                    <h5 *ngIf="xenLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                    <div style="padding: 0 1em;">
                        <p-card styleClass="p-card-shadow my-2 widthFull"
                            *ngFor="let item of xengeolocationsarray; let i=index">
                            <!-- <table cellspacing="1"> -->
                            <table cellspacing="10" style="margin-left: -12px;">
                                <tr>
                                    <td><b>{{'CORNER_ID'| translate}}</b></td>
                                    <td class="surveyEstimateTable"><b>{{item.CornerID}}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td><b>{{'LATITUDE'| translate}}</b></td>
                                    <td class="surveyEstimateTable">{{item.lat}}</td>
                                </tr>
                                <tr>
                                    <td><b>{{'LONGITUDE'| translate}}</b></td>
                                    <td class="surveyEstimateTable">{{item.lng}}</td>
                                </tr>
                                <tr *ngIf="xenLogin">
                                    <td><b>{{'ACTIONS'| translate}}</b></td>
                                    <td>
                                        <button (click)="onDelect(i, 'true')" pButton pRipple type="button"
                                            icon="pi pi-times" class="p-button-success mr-2 mb-2 size-btn"></button>
                                    </td>
                                </tr>
                            </table>

                        </p-card>
                        <p-gmap *ngIf="xengeolocationsarray && xengeolocationsarray.length>0" #gmap
                            [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="xenMapoptions"
                            [overlays]="xenMapoverlays"></p-gmap>

                        <!-- </div> -->
                        <div *ngIf="xenLogin" class="my-2 proDataButton">
                            <p class="invalid-feedback"
                                *ngIf="xengeolocationsarray && xengeolocationsarray.length<4 && coordinateError">
                                {{coordinateError}}</p>
                            <button pButton pRipple type="submit" (click)="onCapture(true)"
                                label="{{'CAPTURE_GPS_COORDINATES'| translate}}"
                                class="p-button-info mr-2 mb-2"></button>
                        </div>
                    </div>
                </div>
                <div class="card hidden md:block">
                    <h5 *ngIf="!jeorxenLogin">{{'XEN_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})
                    </h5>
                    <h5 *ngIf="xenLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                    <div *ngIf="xengeolocationsarray && xengeolocationsarray.length>0" class="dashboardTable">
                        <p-table [value]="xengeolocationsarray" #geolocationsarrayTable dataKey="AppID" [rows]="10"
                            responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>{{'CORNER_ID' | translate}}
                                        <!-- <p-columnFilter type="text" field="CornerID" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="CornerID"></p-sortIcon> -->
                                    </th>
                                    <th>{{'LATITUDE'| translate}}
                                        <!-- <p-columnFilter type="text" field="lat" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="lat"></p-sortIcon> -->
                                    </th>
                                    <th>{{'LONGITUDE'| translate}}
                                        <!-- <p-columnFilter type="text" field="lng" display="menu"></p-columnFilter> -->
                                        <!-- <p-sortIcon field="lng"></p-sortIcon> -->
                                    </th>
                                    <th *ngIf="xenLogin">{{'ACTIONS'| translate}}</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                <tr>
                                    <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                    <td class="surveyEstimateTable">{{product.lat}}</td>
                                    <td class="surveyEstimateTable">{{product.lng}}</td>
                                    <td *ngIf="xenLogin" class="surveyEstimateTable">
                                        <button (click)="onDelect(rowIndex, true)" pButton pRipple type="button"
                                            icon="pi pi-times" class="p-button-success mr-2 mb-2 size-btn"></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="summary">
                                <div class="flex align-items-center justify-content-between">
                                    {{'IN_TOTAL_THERE_ARE'| translate}} {{xengeolocationsarray ?
                                    xengeolocationsarray.length : 0 }} {{'CAPTURE_GPS_COORDINATES_ADDED' | translate}}.
                                </div>
                            </ng-template>
                        </p-table>
                        <p-gmap *ngIf="xengeolocationsarray && xengeolocationsarray.length>0" #gmap
                            [style]="{'height':'250px', 'margin-bottom': '1em'}" [options]="xenMapoptions"
                            [overlays]="xenMapoverlays"></p-gmap>

                    </div>
                    <div *ngIf="xenLogin" class="my-2 proDataButton">
                        <p class="invalid-feedback"
                            *ngIf="xengeolocationsarray && xengeolocationsarray.length<4 && coordinateError">
                            {{coordinateError | translate}}</p>
                        <button pButton pRipple type="submit" (click)="onCapture(true)"
                            label="{{'CAPTURE_GPS_COORDINATES' | translate}}" class="p-button-info mr-2 mb-2"></button>
                    </div>

                </div>
                <!-- Hidden on small screens -->
            </div>

        </form>
        <button (click)="onBasicDetailsFormSubmit()" pButton pRipple type="button" label="Save & Next"
            class="p-button-success mr-2 mb-2"></button>
    </div>
</div>